import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import React from "react";
import { useAccountDeletionsTable } from "./useAccountDeletionsTable";

const tableHead = [
  "CPF",
  "Motivo",
  "Detalhes",
  "Data da solicitação",
  "Status",
  "Ações",
];

export const AccountDeletionsTable: React.FC = () => {
  const { loading, error, properties, requestRows } =
    useAccountDeletionsTable();

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "1rem",
          marginBottom: "1rem",
        }}
      >
        <h2>Solicitações de exclusão de conta</h2>
      </div>

      {loading ? (
        <Loading />
      ) : error ? (
        <PlaceHolderNotExists title="Erro ao se comunicar com o servidor" />
      ) : requestRows.length === 0 ? (
        <PlaceHolderNotExists title="Nenhuma solicitação de exclusão de conta até o momento" />
      ) : (
        <>
          <TableModifiedCards properties={properties} />
          <TableModifiedTable headerColumns={tableHead} rows={requestRows} />
        </>
      )}
    </div>
  );
};
